/***********************************************************************************************************************
* Using this script
************************************************************************************************************************

Create an args object that contains the member variables documented below.

Additional members dataTable and editor will be added by the helper methods in the DataTablesManager
Create the table by calling DataTables.createAndShowTable( args );

Settings arrays are created when they are needed even though that means the fields array is parsed more than once
We do this to reduce bloating in the args object and keep the methods smaller and focused

args fields structure

tableId: 		table id string for use in jQuery selectors

readTableName: 	table or view in the database used to display data
editTableName: 	table in the database that is modified when create, edit, or remove requests are made
primaryKey: 	column name used as the id by MySQL and datatables.net for both tables

hasColumnFilters: 	select whether to allow column filtering - should be false (or not set) on large tables
canSearch:			select whether to allow searching - should be false (or not set) on large tables
canSort:			select whether to allow column sorting - should be false (or not set) on large tables

pagelength:			optional results per page setting. default value is 50
paging:             set to false to disable pagination
ajax:               set to false to disable AJAX server link

editCallback:		optionalFunction that is fired after an edit event from the editor

Ajax action endpoints
these also serve as flags as to whether to show the editor buttons or add the autofill eventListener
actionData:			'datatable',
actionAutofill: 	'datatable_autofill',
actionCreate:		'datatable_create',
actionEdit:			'datatable_edit',
actionRemove:		'datatable_remove',

ajaxDataCallback : function( data, settings ) 		A function that allows customizaiton of the ajax data requests

fields: array of column objects with the following fields in display order
	label - used as the label in the editor - the column titles are declared in the html
	columnName - name of the column or object that contains the label and value members
	isObject - **OPTIONAL** boolean that indicates whether this is a simple column name (false) or object (true)
	isEditable - **OPTIONAL** boolean that indicates whether this is an editable field
	sort - **OPTIONAL** either asc or desc, determines the default table sort - best if only set on one column
	type - **OPTIONAL** type of input renderedby editor
	options - **OPTIONAL** options to be used when rendering as a select

*/

jQuery(function( $ ) {
	'use strict'

	function renderDate( data, type, row, meta ) {
		return data ? moment(data).format('l') : '';
	}
	function renderCheckbox( data, type, row, meta ) {
		return '<div class="center-text"><span class="far fa-' +
			( data && data != '0' ? 'check-' : '' ) +
			'square" aria-label="' +
			( data && data != '0' ? 'Yes' : 'No' ) +
			'"></span></div>';
	}
	function renderSampleLink( data, type, row, meta ) {
		if ( ! data ) { return ''; }
		const sampleNumber = row.SampleNumber !== undefined ? row.SampleNumber : data;
		const dataSampleNumber = ' data-sample-number="' + sampleNumber + '"';
		if ( row.SampleExists === false ) {
			return '<div title="Sample # ' + sampleNumber + ' does not exist" class="alert-missing">' + data + '</div>';
		}
		return '<a href="#" class="sample-link"' + dataSampleNumber + '>' + data + '</a>';
	}
	function renderProjectLink( data, type, row, meta ) {
		return '<a href="#" class="project-link" data-job-number="' + data + '">' + data + '</a>';
	}
	function renderViewProjectDataLink( data, type, row, meta ) {
		return '<a href="#" class="view-project-data-link" data-job-number="' + data + '">' + data + '</a>';
	}
	function renderProjectNameLink( data, type, row, meta ) {
		if ( ! row.ProjectID ) { return data !== null ? data : ''; }
		return '<a href="#" class="project-name-link" data-project-id="' + row.ProjectID + '">' + data + '</a>';
	}
	function renderClientLink( data, type, row, meta ) {
		if ( ! row.ClientID ) return  data !== null ? data : '';
		return '<a href="#" class="client-link" data-client-id="' + row.ClientID + '">' + data + '</a>';
	}
	function renderColumnLetter( data, type, row, meta ) {
		const index = parseInt( data );
		if ( index != 0 && ! index ) { return data != null ? data : ''; }
		if ( index < 26 ) { return String.fromCharCode( 65 + index ); }
		return String.fromCharCode( 64 + index / 26 ) + String.fromCharCode( 65 + index % 26 );
	}
	function renderOption( options, data, type, row, meta ) {
		const option = options.find( option => option.value !== undefined && option.value == data );
		if ( typeof option != 'object' || option.label === undefined ) { return data; }
		return option.label;
	}
	function renderDnrTest( data, type, row, meta ) {
		const option = DataTablesManager.getDnrTestOptions().find( option => option.value !== undefined && option.value == data );
		if ( typeof option != 'object' || option.label === undefined ) { return data; }
		return option.label;
	}
	function renderResult( data, type, row, meta ) {
		//console.log( meta.settings );
		const asFloat = parseFloat( data );
		if ( ! asFloat && asFloat != 0 ) return data;
		const isOutlier = row.ResultStandardDeviation
			? Math.abs( asFloat - row.ResultAverage ) / row.ResultStandardDeviation
				>= store.state.outlierStandardDeviationRatio
			: row.ResultStandardDeviations
			? row.ResultStandardDeviations >= store.state.outlierStandardDeviationRatio
			: false;
		return  isOutlier ? '<div class="alert-danger">' + data + '</div>' : data;
	}

	function renderAnalyteOptions(data, type, row, meta) {
		const option = DataTablesManager.getAnalytesOptions().find( option => option.value !== undefined && option.value == data );
		if ( typeof option != 'object' || option.label === undefined ) { return data; }
		return option.label;
	}

	window.maybeAnalyteOptions = [{label:"",value:null}];

	function renderMaybeAnalyte( data, type, row, meta ) {
		if ( data == null )
			return '';
		const option = window.analyteOptions.find( option => option.value !== undefined && option.value == data );
		if ( typeof option != 'object' || option.label === undefined ) { return data; }
		return option.label;
	}


	window.DataTablesManager = {

		renderAnalyte( data, type, row, meta ) {
			return renderMaybeAnalyte( data, type, row, meta );
		},

		/**
		* Uses the args object to build and show a DataTable
		*/
		createAndShowTable: function( args, onCreated = null ){
			let needAnalytes = false;
			for ( const field of args.fields ) {
				if ( field.type == 'maybe-analyte' )
					needAnalytes = true;
			}
			function innerCreateAndShowTable() {
				if ( needAnalytes ) {
					window.ajaxCall({
						data : {
							action: 'get_analyte_options',
						},
						onSuccess : function( response ) {
							const data = response.data;
							if (data === undefined || ! data['analyteOptions']) {
								console.error('get_analyte_options returned:', data);
								return;
							}
							window.analyteOptions = data['analyteOptions'];
							window.maybeAnalyteOptions = [{label:"",value:null}].concat(window.analyteOptions);
						},
						onError : function ( response ) {
							const message = 'Failed to load field analyte options';
							console.error( message );
						},
						onComplete() {
							needAnalytes = false;
							innerCreateAndShowTable();
						}
					});
				} else {
					let table = document.querySelector( args.tableId );
					if ( ! table && args.container ) {
						table = document.createElement( 'table' );
						args.container.appendChild( table );
						table.id = args.tableId.substring( 1 );
					}
					if ( table.childNodes.length == 0 ) {
						table.className = 'display';
						table.style.width = '100%';
						table.style.visibility = 'hidden';
						function makeHeaders( tpartType ) {
							const tpart = document.createElement( tpartType );
							table.appendChild( tpart );
							let tr = document.createElement( 'tr' );
							tpart.appendChild( tr );
							for ( const field of args.fields ) {
								const th = document.createElement( 'th' );
								tr.appendChild( th );
								th.innerText = field.label;
							}
							return tpart;
						}
						const thead = makeHeaders( 'thead' );
						if ( args.hasColumnFilters && args.canSearch ) {
							const tr = document.createElement( 'tr' );
							tr.className = 'column-search'
							thead.appendChild( tr );
							for ( const field of args.fields ) {
								const th = document.createElement( 'th' );
								tr.appendChild( th );
								if ( field.type == 'date' ) {
									const input = document.createElement( 'input' );
									th.appendChild( input );
									input.type = 'date';
								} else if ( field.type == 'boolean' ) {
									const select = document.createElement( 'select' );
									th.appendChild( select );
									select.className = 'checkbox';
									let option = document.createElement( 'option' );
									option.value = '';
									option.innerText = '';
									select.appendChild( option );
									option = document.createElement( 'option' );
									option.value = '0';
									option.innerText = '';
									select.appendChild( option );
									option = document.createElement( 'option' );
									option.value = '1';
									option.innerText = '';
									select.appendChild( option );
								} else if ( field.type == 'test' || field.type == 'maybe-test' || field.type == 'dnr-test'
										|| field.type == 'maybe-analyte' || field.type == 'analyte' || field.options ) {
									const options = ( field.type == 'test' || field.type == 'maybe-test' )
										? DataTablesManager.getTestOptions()
										: field.type == 'dnr-test'
										? DataTablesManager.getDnrTestOptions()
										: ( field.type == 'maybe-analyte' || field.type == 'analyte' )
										? DataTablesManager.getAnalytesOptions()
										: field.options;
									const select = document.createElement( 'select' );
									th.appendChild( select );
									if ( options.find( option => option.value == '' ) === undefined ) {
										const selectOption = document.createElement( 'option' );
										selectOption.value = '';
										selectOption.innerText = '';
										select.appendChild( selectOption );
									}
									for ( const option of options ) {
										const selectOption = document.createElement( 'option' );
										selectOption.value = option.value;
										selectOption.title = option.label;
										selectOption.innerText = option.label;
										select.appendChild( selectOption );
									}
								} else {
									const input = document.createElement( 'input' );
									th.appendChild( input );
									input.type = 'text';
									if ( field.datalist ) {
										input.setAttribute( 'list', 'datalist-' + field.datalist );
									} else {
										const datalist = document.createElement( 'datalist' );
										th.appendChild( datalist );
										input.setAttribute( 'list', datalist.id = table.id + '-datalist-' + field.columnName );
									}
								}
							}
						}
						makeHeaders( 'tfoot' );
					}
					if ( args.hasColumnFilters ) {
						DataTablesManager.addColumnSearchEventHandler( args );
					}
					if ( DataTablesManager.getEditableFields( args ).length != 0 ) {
						DataTablesManager.addInlineEditEventHandler( args );
						DataTablesManager.initializeEditor( args );
					}
					DataTablesManager.initializeDataTable( args );
					DataTablesManager.showTable( args );
					typeof onCreated == 'function' && onCreated( args.dataTable );
				}
			}
			innerCreateAndShowTable();
		},

/**********************************************************************************************************************
EventListeners
**********************************************************************************************************************/

		/**
		* Add eventListener that triggers the column search
		*/
		addColumnSearchEventHandler: function( args ) {
			$( args.tableId + ' thead tr.column-search input' ).on( 'keyup change', function () {

				const _this 			= this,
					index 				= $( this ).parent().index(),
					datalist 			= $( this ).siblings( 'datalist' ),
					dataTableColumn 	= args.dataTable.column( index ),
					field				= args.fields[index];

				if ( dataTableColumn.search() !== this.value ) {

					dataTableColumn.search( this.value ).draw();

					if ( ! datalist ) { return }


					if ( this.value.length == 3 && args.actionAutofill ) {
						// Populate the autofill options when there are 3 charachters in the field

						window.ajaxCall({
							data: {
								action: args.actionAutofill,
								tableName: args.readTableName,
								columnName: field.columnName,
								searchText: this.value,
							},
							onSuccess: function( response ) {
								response.data.forEach( function( suggestion ) {
									datalist.append( '<option value="' + suggestion + '"><option/>"' );
								});
								_this.focus();
							}
						});

					} else if ( this.value.length < 3 ) {
						// Clear the autofill options
						datalist.empty();
					}
				}

			});
			$( args.tableId + ' thead tr.column-search select' ).on( 'keyup change', function () {

				const _this 			= this,
					index 				= $( this ).parent().index(),
					dataTableColumn 	= args.dataTable.column( index ),
					options             = this.selectedOptions,
					value               = options.length ? options[0].value : '';
				this.title = options.length ? options[0].innerText : null;
				if ( dataTableColumn.search() !== value ) {
					dataTableColumn.search( value ? '=' + value : '' ).draw();
				}	
			});
		},

		/**
		* Add eventListener that triggers the inline editor when table cells are clicked
		*/
		addInlineEditEventHandler: function( args ) {
			/* const editableColumnsSelectorString = DataTablesManager.getEditableColumnIndexes( args )
				.map( x => 'tr td:nth-of-type(' + ( x + 1 ) + ')' )
				.join( ', ' );

			$( args.tableId ).on( 'click', editableColumnsSelectorString, function() {
				args.editor.inline( this );
			});

			$( args.tableId ).on( 'key-blur', function ( e, datatable, cell ) {
			 	args.editor.blur();
			} ); */
		},

/**********************************************************************************************************************
Initialize and Show
**********************************************************************************************************************/

		/**
		* Initialize the Editor object using the args object and some helper functions
		*/
		initializeEditor: function( args ) {
			args.editor = new $.fn.dataTable.Editor( {
				table: 			args.tableId,
				idSrc: 			args.primaryKey,
				formOptions: 	{
					inline: {
						drawType: 'none',
						onBlur: 'submit',
						submit: 'allIfChanged',
						onReturn: function(e){
							//first submit
							if(args.editor.display() == 'inline'){
								args.editor.submit();
							}							//then check if needing to switch cell
							let index = args.dataTable.cell({focused:true}).index();
							if( JSON.stringify(index) === JSON.stringify(DataTablesManager.lastCellClicked)){
								if(args.dataTable.shiftPressed && args.dataTable.row(":first-child").index() != index.row) {
									index.row -= 1;
								} else if (!args.dataTable.shiftPressed && args.dataTable.row(":last-child").index() != index.row){
									index.row += 1;
								}
								let cell = args.dataTable.cell(index);
								DataTablesManager.lastCellClicked = index;
								cell.focus();
								if(args.editor.display() != 'inline' && action == "edit"){
									if(index) args.editor.inline(index);				
								}
							} 
						}
					},
				},
				ajax:			args.ajax !== false ? DataTablesManager.getEditorAjaxObject( args ) : null,
				fields: 		DataTablesManager.getEditableFields( args ),
			});
			if ( args.hasOwnProperty( 'editCallback' ) && typeof args.editCallback == 'function' ) {
				args.editor.on( 'postSubmit', args.editCallback );
			}
			args.editor.on( 'initEdit', function ( e, node, data, items, type ) {
				if(type == 'inline') {
					let column = DataTablesManager.getColumns(args)[items.column];
					let field = args.editor.field(column.data);
					if(DataTablesManager.getLastSetDate() && column.type == 'inputDate') {
						let fieldData = field.get();
						if(!fieldData ) {
							field.set(DataTablesManager.getLastSetDate());
						}
					}
					field.input().select();
				}
			}).on( 'submitComplete', function( e, json, data, action ) {
				if(args.editor.display() != 'inline' && action == "edit"){
					let index = args.dataTable.cell({focused:true}).index();
					if(index) args.editor.inline(index);				
				}
			});
		},

		/**
		* Initialize the DataTable object using the args object and some helper functions
		*/
	initializeDataTable: function( args ) {
			const initializationInfo = {
				deferRender:	true,
				serverSide:		args.ajax !== false,
				processing:		true,

				// Show an alert if there was an issue on the server
				preDrawCallback: function( settings ) {
					if ( settings.hasOwnProperty( 'json' )
						&& settings.json.hasOwnProperty( 'success')
						&& settings.json.success == false
					) {
						//console.log( settings.json.data );
						window.WarningModalManager.show({
							title: "A DataTable Draw Request Returned an Error",
							message: typeof settings.json.data == 'string'
								? settings.json.data
								: JSON.stringify( settings.json.data ),
						});
					}
				},
				drawCallback: function( settings ) {
					const rows = settings.nTBody.rows;
					for ( let r = 0; r < rows.length; ++r ) {
						const cells = rows[r].cells;
						for ( let c = 0; c < cells.length; ++c ) {
							const cell = cells[c];
							if ( cell.childNodes.length == 0
									|| ! ( cell.childNodes[0] instanceof HTMLDivElement ) ) {
								continue;
							}
							const div = cell.childNodes[0];

							// This may break with an upgrade in the future
							const columnClassName = settings.aoColumns[c].className || '';
							cell.title = div.title;
							cell.className = columnClassName
								+ ( columnClassName.length || div.className.length ? ' ' : '' )
								+ div.className;
							cell.append( ... div.childNodes );
							div.remove();
						}
					}
				},
				createdRow: args.createdRow,

				orderCellsTop:	true,
				select: {
					style:    'os',
					selector: 'td:first-child',
					blurable: true
				},
				lengthMenu: 	[ [ 25, 50, 100, 250, 500, 2000 ], [ 25, 50, 100, 250, 500, '2000' ] ],
				pageLength: 	args.pagelength ? args.pagelength : 2000,
				paging:         args.paging !== false,
				info:           args.paging !== false,
				keys: {
					blurable: true,
					columns: DataTablesManager.getEditableColumnIndexes( args ),
				},
				ajax:			args.ajax !== false ? DataTablesManager.getDataTableAjaxObject( args ) : null,
				searching: 		DataTablesManager.getIsSearchable( args ),
				ordering:		DataTablesManager.getIsSortable( args ),
				order:			DataTablesManager.getDefaultSortOrder( args ),
				dom:			DataTablesManager.getDataTableDomString( args ),
				buttons:		DataTablesManager.getDataTableButtons( args ),
				columns:		DataTablesManager.getColumns( args ),
			};
			if ( args.editor ) {
				initializationInfo.keys.editor = args.editor;
			}
			
			args.dataTable = $( args.tableId ).DataTable( initializationInfo );

			if(args.editor){
				args.dataTable.on( 'key-blur', function ( e, datatable, cell, originalEvent ) {
					if(args.editor.display() == 'inline'){
						args.editor.submit();
					}
				}).on( 'key-focus', function ( e, datatable, cell, originalEvent ) {
					let index = cell.index();
					DataTablesManager.lastCellClicked = index;
					if(args.editor.display() != 'inline'){
						args.editor.inline(index);				
					}
				}).on("keydown", function(e){
					//implementing the excel type enter key function.  See initializeEditor/onReturn 
					if(e.shiftKey){
						args.dataTable.shiftPressed = true;
					}
				}).on("keyup", function(e){
					if(!e.shiftKey){
						args.dataTable.shiftPressed = false;
					}
				});
			}
		},

		/**
		* Show rendered table
		* The _wrapper and display classes are automatically created by DataTables and we hide them with CSS before
		* initializing the table.
		*/
		showTable: function( args ) {
			$( args.tableId + '_wrapper .display' ).css( 'visibility', 'visible' );
			$( args.tableId + '_wrapper' ).fadeIn( 'slow' );
		},

/**********************************************************************************************************************
Settings Object Helpers
**********************************************************************************************************************/

		/*
		* Uses the args object to create an array used by the DataTables constructor to determine which buttons to
		* display
		*/
		getDataTableButtons: function( args ) {
			const buttons = [];
			if ( args.actionCopy || args.exportActions ) {
				buttons.push( { extend: 'copyHtml5' } );
			}
			if ( args.actionCsv || args.exportActions ) {
				buttons.push( { extend: 'csvHtml5' } );
			}
			if ( args.actionExcel || args.exportActions ) {
				buttons.push( { extend: 'excelHtml5' } );
			}
			if ( args.actionPdf || args.exportActions ) {
				buttons.push( { extend: 'pdf' } );
			}
			if ( args.actionPrint || args.exportActions ) {
				buttons.push( { extend: 'print' } );
			}
			if ( args.editor ) {
				buttons.push( { extend: 'selectAll', editor: args.editor } );
				if ( args.actionCreate ) {
					buttons.push( { extend: 'create', editor: args.editor } );
				}
				if ( args.actionEdit ) {
					buttons.push( { extend: 'edit',   editor: args.editor } );
				}
				if ( args.actionRemove ) {
					buttons.push( { extend: 'remove', editor: args.editor } );
				}
				buttons.push( { extend: 'selectNone', editor: args.editor } );
			}

			return buttons;
		},

		/**
		* Creates the DataTable ajax object
		*/
		getDataTableAjaxObject: function( args ) {

			const dataCallback = function( data, settings ) {
				data.action = args.actionData;
				data.tableName = args.readTableName;

				if ( args.hasOwnProperty( 'ajaxDataCallback') ) {
				 	data = args.ajaxDataCallback( data, settings );
				}

				data['session_id'] = ajax_object.session_id;

				return JSON.stringify(data);
			}

			const ajaxObject = {
				url: ajax_object.ajax_url,
				data: dataCallback,
				type: 'POST',
				contentType: 'application/json; charset=utf-8',
				dataType: 'json',
			}

			return ajaxObject;

		},

		/**
		* Creates the DataTables Editor ajax object
		*/
		getEditorAjaxObject: function( args ) {
			return {
				url: ajax_object.ajax_url,
				type: 'POST',
				data: function( e ) {
					e.tableName = args.editTableName;
					e.primaryKey = args.primaryKey;
					e['session_id'] = ajax_object.session_id;
					if ( e.action == 'create' ) {
						e.action = args.actionCreate;
					}
					if ( e.action == 'edit' ) {
						e.action = args.actionEdit;
					}
					if ( e.action == 'remove' ) {
						e.action = args.actionRemove;
					}
				},
			}
		},


		/**
		* Uses the args object to create a string used by the DataTables constructor to determine which order to
		* place elements in the layout
		*/
		getDataTableDomString: function( args ) {
			if ( this.getDataTableButtons( args ).length ) {
				return 'lBfrtip'; // Layout with buttons
			}
			return 'lfrtip'; // Layout without buttons
		},


/**********************************************************************************************************************
Fields Processors
**********************************************************************************************************************/

		/**
		* Processes args.fields to get an array of sort data from fields that have sort set
		*/
		getIsSearchable: function( args ) {
			return args.hasOwnProperty( 'canSearch' ) && args.canSearch;
		},

		/**
		* Processes args.fields to get an array of sort data from fields that have sort set
		*/
		getIsSortable: function( args ) {
			return args.hasOwnProperty( 'canSort' ) && args.canSort;
		},

		/**
		* Processes args.fields to get a boolean representing whether column search is enabled
		*/
		getDefaultSortOrder: function( args ) {
			const order = [];

			for ( let index = 0; index < args.fields.length; index++ ) {
				const field = args.fields[ index ];

				if ( field.hasOwnProperty( 'order' ) ) {

					let sortDir = field.order.toLowerCase();

					sortDir = [ 'asc', 'desc' ].includes( sortDir ) ? sortDir : 'asc';

					order.push( [ index, sortDir ] );
				}
			}

			return order;
		},


		/**
		* Processes args.fields to get an array of column indexes of the fields that have isEditable set to true
		*/
		getEditableColumnIndexes: function( args ) {
			const editableColumnIndexes = [];

			for ( let index = 0; index < args.fields.length; index++ ) {
				const field = args.fields[ index ];

				if ( field.hasOwnProperty( 'isEditable' ) && field.isEditable ) {
					editableColumnIndexes.push( index );
				}
			}

			return editableColumnIndexes;
		},


		/**
		* Processes args.fields and returns true if any field has 'isObject' set to true
		*/
		hasColumnDataObjects: function( args ) {
			return args.fields
				.filter( field => field.hasOwnProperty( 'isObject' ) && true == field.isObject )
				.length > 0;
		},

		/**
		* Processes args.fields to get an array of column objects for DataTable initialization
		*/
		getColumns: function( args ) {
			return args.fields.map( DataTablesManager.getDataTableColumnObject );
		},

		/**
		* Return an object with DataTable column settings - DataTablesManager.getColumns calls this
		*/
		getDataTableColumnObject: function( field ) {
			const column = {
				name:	field.label,
				data:	field.columnName,
			};

			if ( field.hasOwnProperty( 'isObject' ) && true == field.isObject ) {
				column.render = { '_' : 'value', display: 'label' };
			}

			if ( field.hasOwnProperty( 'render' ) ) {
				column.render = field.render;
			} else if ( field.hasOwnProperty( 'type' ) ) {
				switch (field.type) {
					case 'boolean':
						column.render = renderCheckbox;
						break;
					case 'date':
						column.type = 'inputDate';
						column.render = renderDate;
						break;
					case 'sample-link':
						column.render = renderSampleLink;
						break;
					case 'project-link':
						column.render = renderProjectLink;
						break;
					case 'project-name-link':
						column.render = renderProjectNameLink;
						break;
					case 'client-link':
						column.render = renderClientLink;
						break;
					case 'view-project-data-link':
						column.render = renderViewProjectDataLink;
						break;
					case 'result':
						column.render = renderResult;
						break;
					case 'columnLetter':
						column.render = renderColumnLetter;
						break;
					case 'dnr-test':
						column.render = renderDnrTest;
						break;
					case 'test':
					case 'maybe-test':
						column.render = DataTablesManager.getTestNameByID;
						break;
					case 'maybe-analyte':
						column.render = renderMaybeAnalyte;
						break;
					case 'analyte':
						column.render = renderAnalyteOptions;
						break;
				}
			}
			if ( ! column.render && field.hasOwnProperty( 'options' ) && typeof field.options == 'object' ) {
				column.render = (data, type, row, meta) => renderOption( field.options, data, type, row, meta );
			}

			if ( field.hasOwnProperty( 'isEditable' ) && field.isEditable ) {
				column.className = 'editable';
			}

			if ( field.hasOwnProperty( 'className' ) ) {
				column.className = column.className ? column.className + ' ' + field.className : field.className;
			}

			if ( field.hasOwnProperty( 'visible' ) ) {
				column.visible = field.visible;
				if ( ! field.visible )
					column.searchable = false;
			}

			if ( field.hasOwnProperty( 'visible' ) ) {
				column.searchable = field.searchable;
			}

			return column;
		},

		/**
		* Processes args.fields to get an array of editable field objects for Editor initialization
		*/
		getEditableFields: function( args ) {
			return args.fields
				.filter( field => field.hasOwnProperty( 'isEditable' ) && true == field.isEditable )
				.map( DataTablesManager.getEditableFieldObject );
		},

		/**
		* Return an object with Editor field settings - DataTablesManager.getEditableFields calls this function
		*/
		getEditableFieldObject: function( field ) {
			const editableField = {
				label:	field.label,
				name:	field.columnName,
			};

			if ( field.hasOwnProperty( 'isObject' ) && true == field.isObject ) {
				editableField.data = field.columnName + '.value';
			}

			if ( field.hasOwnProperty( 'postFilter' ) ) {
				editableField.type = 'inputText';
				editableField.postFilter = field.postFilter;
			}

			if ( field.hasOwnProperty( 'type' ) ) {


				if ( 'boolean' == field.type ) {
					editableField.type = 'checkbox';
					editableField.mRender = renderCheckbox;
				} else if ( 'test' == field.type ) {
					editableField.type = 'select';
					editableField.options = DataTablesManager.getTestOptions();
				} else if ( 'dnr-test' == field.type ) {
					editableField.type = 'select';
					editableField.options = DataTablesManager.getDnrTestOptions();
				} else if ( 'maybe-test' == field.type ) {
					editableField.type = 'select';
					editableField.options = DataTablesManager.getOptionalTestOptions();
				} else if ( 'analyte' == field.type ) {
					editableField.type = 'select';
					editableField.options = DataTablesManager.getAnalytesOptions();
				} else if ( 'maybe-analyte' == field.type ) {
					editableField.type = 'select';
					editableField.options = maybeAnalyteOptions;
				} else if ( 'columnLetter' == field.type ) {
					editableField.type = 'select';
					editableField.options = DataTablesManager.getColumnLetterOptions();
				} else if ( 'date' == field.type ) {
					editableField.type = 'inputDate';
					editableField.mRender = renderDate;
				} else if ( 'number' == field.type ) {
					editableField.type = 'inputNumber';
				} else if ( 'result' == field.type ) {
					editableField.type = 'text';
					editableField.mRender = renderResult;

				// we have a custom type - combobox... Maybe that code belongs in this file or near here? js/datatables-editor-combobox.js
				} else if ( 'combobox' == field.type ) {
					editableField.type = 'combobox';
					editableField.datalist = field.datalist;

				} else {
					editableField.type = field.type;
					if ( field.hasOwnProperty( 'options' ) ) {
						editableField.options = field.options;
					}
				}
			}

			return editableField;
		},


/**********************************************************************************************************************
Select Options
**********************************************************************************************************************/

		/**
		* Returns a suitable options array for boolean select rendering by the DataTables Editor addon
		*/
		getBooleanOptions: function() {
			return [
				{ label: 'No', value: 0 },
				{ label: 'Yes', value: 1 }
			];
		},

		/**
		* Returns a suitable options array for column letters select rendering by the DataTables Editor addon
		*/
		getColumnLetterOptions: function() {
			return [
				{ label: '', value: null },
				{ label: 'A', value: 0 },
				{ label: 'B', value: 1 },
				{ label: 'C', value: 2 },
				{ label: 'D', value: 3 },
				{ label: 'E', value: 4 },
				{ label: 'F', value: 5 },
				{ label: 'G', value: 6 },
				{ label: 'H', value: 7 },
				{ label: 'I', value: 8 },
				{ label: 'J', value: 9 },
				{ label: 'K', value: 10 },
				{ label: 'L', value: 11 },
				{ label: 'M', value: 12 },
				{ label: 'N', value: 13 },
				{ label: 'O', value: 14 },
				{ label: 'P', value: 15 },
				{ label: 'Q', value: 16 },
				{ label: 'R', value: 17 },
				{ label: 'S', value: 18 },
				{ label: 'T', value: 19 },
				{ label: 'U', value: 20 },
				{ label: 'V', value: 21 },
				{ label: 'W', value: 22 },
				{ label: 'X', value: 23 },
				{ label: 'Y', value: 24 },
				{ label: 'Z', value: 25 },
				{ label: 'AA', value: 26 },
				{ label: 'AB', value: 27 },
				{ label: 'AC', value: 28 },
				{ label: 'AD', value: 29 },
				{ label: 'AE', value: 30 },
				{ label: 'AF', value: 31 },
			];
		},

		/**
		* Returns a suitable options array for "Test" select rendering by the DataTables Editor addon
		*/
		getTestOptions: function() {
			// get the testList from the data store
			const testList = store.state.testList;
			const testNameOptions = testList.map( function( test ) {
				return { label: test.testName, value: test.id };
			});
			return testNameOptions;
		},

		/**
		* Returns a suitable options array for "Test" select rendering by the DataTables Editor addon
		*/
		getDnrTestOptions: function() {
			return [ { label: '', value: null } ].concat( store.state.dnrTestList );
		},

		/**
		* Returns a suitable options array for "Test" select rendering by the DataTables Editor addon
		*/
		getOptionalTestOptions: function() {
			const testNameOptions = this.getTestOptions();
			testNameOptions.unshift( { label: '', value: null } );
			return testNameOptions;
		},

		/**
		* Returns "Test" name by ID for rendering by the DataTables Editor addon
		*/
		getTestNameByID: function(id) {
			// get the testList from the data store
			const testList = store.state.testList;
			const test = testList.find( test => test.id == id );
			return test !== undefined ? test.testName : '';
		},

		getAnalyteNameByID: function(id) {
			const analyteOptions = store.state.analyteOptions;
			const analyte = analyteOptions.find(analyte => analyte.value == id);
			return analyte !== undefined ? analyte.label : '';
		},

		getAnalytesOptions: function() {
			return [ { label: '', value: null } ].concat(store.state.analyteOptions);
		},

		getLastSetDate: function(date) {
			let newDate = date;
			if(!date && DataTablesManager.lastSetDate) 
				newDate = DataTablesManager.lastSetDate;
			return newDate;
		}

	}

	const DataTable = jQuery.fn.dataTable;
	/// Custom Edit Controls
	if ( ! DataTable.ext ) {
		DataTable.ext = {};
	}
	if ( ! DataTable.ext.editorFields ) {
		DataTable.ext.editorFields = {};
	}

	DataTable.ext.editorFields.inputDate = {
		create: function ( conf ) {
			// Create the elements to use for the input
			conf._input = $('<input type="date" />');
			conf._input.attr( 'id', conf.id );
			conf._input.attr( 'value', conf.value );

			return conf._input;
		},

		get: function ( conf ) {
			let value = conf._input.attr('value')
			if(value)
				window.DataTablesManager.lastSetDate = value;
			return value;
		},

		set: function ( conf, value ) {
			conf._input.attr('value', value);
		},

		enable: function ( conf ) {
			conf._input.removeAttr( 'disabled' );
		},

		disable: function ( conf ) {
			conf._input.attr( 'disabled', 'disabled' );
		},

		canReturnSubmit: function ( conf, node ) {
			return true;
		},
	};

	DataTable.ext.editorFields.inputText = {
		create: function ( conf ) {
			// Create the elements to use for the input
			conf._input = $( '<input type="text" />');
			conf._input.attr( 'id', conf.id );
			conf._input.attr( 'value', conf.value );

			return conf._input;
		},

		get: function ( conf ) {
			return conf._input.attr( 'value' ) || '';
		},

		set: function ( conf, value ) {
			conf._input.attr( 'value', conf.postFilter ? conf.postFilter( value ) : value );
		},

		enable: function ( conf ) {
			conf._input.removeAttr( 'disabled' );
		},

		disable: function ( conf ) {
			conf._input.attr( 'disabled', 'disabled' );
		},

		canReturnSubmit: function ( conf, node ) {
			return true;
		},
	};

	DataTable.ext.editorFields.inputNumber = {
		create: function ( conf ) {
			// Create the elements to use for the input
			conf._input = $( '<input type="number" />');
			conf._input.attr( 'id', conf.id );
			conf._input.attr( 'value', conf.value );

			return conf._input;
		},

		get: function ( conf ) {
			return conf._input.attr( 'value' ) || '';
		},

		set: function ( conf, value ) {
			conf._input.attr( 'value', conf.postFilter ? conf.postFilter( value ) : value );
		},

		enable: function ( conf ) {
			conf._input.removeAttr( 'disabled' );
		},

		disable: function ( conf ) {
			conf._input.attr( 'disabled', 'disabled' );
		},

		canReturnSubmit: function ( conf, node ) {
			return true;
		},
	};

	DataTable.ext.editorFields.checkbox = {
		create: function ( conf ) {
			if ( ! conf ) { return null; }
			// Create the elements to use for the input
			const open = '<div style="text-align:center"><input type="checkbox" style="display:inline-block" id="';
			conf._input = $(open+DataTable.Editor.safeId( conf.id )+'" '+(conf.value == '1' ? 'checked' : '')+' /></div>');

			return conf._input;
		},

		get: function ( conf ) {
			return conf && conf._input && conf._input.length
				? ( conf._input[0].firstChild.checked ? '1' : '0' )
				: null;
		},

		set: function ( conf, value ) {
			if ( conf && conf._input && conf._input.length )
				conf._input[0].firstChild.checked = value == '1' ? 'checked' : null;
		},

		enable: function ( conf ) {
			if ( conf && conf._input && conf._input.length )
				conf._input[0].firstChild.disabled = null;
		},

		disable: function ( conf ) {
			if ( conf && conf._input && conf._input.length )
				conf._input[0].firstChild.disabled = 'disabled';
		},

		canReturnSubmit: function ( conf, node ) {
			return true;
		},
	};
});
